var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { IconTick } from '../../../atoms/icons/16x16/Tick';
import { theme } from '../../../theme';
import { CheckBoxButtonStyles } from './CheckBoxButtonStyles';
export var ButtonCheckbox = function (_a) {
    var className = _a.className, checked = _a.checked, label = _a.label, onClick = _a.onClick, secondary = _a.secondary, error = _a.error, tabFocusTrap = _a.tabFocusTrap;
    var _b = useState(), isChecked = _b[0], setChecked = _b[1];
    useEffect(function () {
        setChecked(checked || false);
    }, [checked]);
    var handleButtonClicked = function () {
        setChecked(!isChecked);
        if (onClick) {
            onClick();
        }
    };
    return (_jsxs(CheckBoxButtonStyles, __assign({ secondary: secondary, checked: isChecked, onClick: handleButtonClicked, className: className, error: error, tabFocusTrap: tabFocusTrap }, { children: [_jsx("div", { children: _jsx("div", __assign({ className: "checkbox" }, { children: isChecked && _jsx(IconTick, { fill: theme.primaryColours.white.main }) })) }), _jsx("span", { children: label })] })));
};
